/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetProducts200ResponseItemsInnerAllergensInner } from './GetProducts200ResponseItemsInnerAllergensInner';
import {
    GetProducts200ResponseItemsInnerAllergensInnerFromJSON,
    GetProducts200ResponseItemsInnerAllergensInnerFromJSONTyped,
    GetProducts200ResponseItemsInnerAllergensInnerToJSON,
    GetProducts200ResponseItemsInnerAllergensInnerToJSONTyped,
} from './GetProducts200ResponseItemsInnerAllergensInner';

/**
 * 
 * @export
 * @interface CreateModifierRequest
 */
export interface CreateModifierRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateModifierRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateModifierRequest
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateModifierRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateModifierRequest
     */
    priceImpact: number;
    /**
     * 
     * @type {string}
     * @memberof CreateModifierRequest
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateModifierRequest
     */
    kitchenName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateModifierRequest
     */
    shortName?: string;
    /**
     * 
     * @type {Array<GetProducts200ResponseItemsInnerAllergensInner>}
     * @memberof CreateModifierRequest
     */
    allergens?: Array<GetProducts200ResponseItemsInnerAllergensInner>;
}

/**
 * Check if a given object implements the CreateModifierRequest interface.
 */
export function instanceOfCreateModifierRequest(value: object): value is CreateModifierRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('priceImpact' in value) || value['priceImpact'] === undefined) return false;
    return true;
}

export function CreateModifierRequestFromJSON(json: any): CreateModifierRequest {
    return CreateModifierRequestFromJSONTyped(json, false);
}

export function CreateModifierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateModifierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'priceImpact': json['priceImpact'],
        'color': json['color'] == null ? undefined : json['color'],
        'kitchenName': json['kitchenName'] == null ? undefined : json['kitchenName'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'allergens': json['allergens'] == null ? undefined : ((json['allergens'] as Array<any>).map(GetProducts200ResponseItemsInnerAllergensInnerFromJSON)),
    };
}

export function CreateModifierRequestToJSON(json: any): CreateModifierRequest {
    return CreateModifierRequestToJSONTyped(json, false);
}

export function CreateModifierRequestToJSONTyped(value?: CreateModifierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'priceImpact': value['priceImpact'],
        'color': value['color'],
        'kitchenName': value['kitchenName'],
        'shortName': value['shortName'],
        'allergens': value['allergens'] == null ? undefined : ((value['allergens'] as Array<any>).map(GetProducts200ResponseItemsInnerAllergensInnerToJSON)),
    };
}

